import {
  CHANGE_PASSWORD_COMPLETE,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_PENDING,
  ChangePasswordActions,
  ChangePasswordReducerState,
} from 'services/AuthService/ChangePassword/types';

const INITIAL_STATE = {
  passwordChangeIsCompleted: false,
  passwordChangeIsPending: false,
  passwordChangeIsError: null,
};

const passwordChangeReducer = (previousState: ChangePasswordReducerState | undefined, action: ChangePasswordActions) => {
  const state = previousState ?? INITIAL_STATE;

  switch (action.type) {
    case CHANGE_PASSWORD_COMPLETE:
      return {
        ...state,
        passwordChangeIsCompleted: true,
        passwordChangeIsPending: false,
        passwordChangeIsError: null,
      };
    case CHANGE_PASSWORD_PENDING:
      return {
        ...state,
        passwordChangeIsCompleted: false,
        passwordChangeIsPending: true,
        passwordChangeIsError: null,
      };
    case CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        passwordChangeIsCompleted: true,
        passwordChangeIsPending: false,
        passwordChangeIsError: action.error,
      };

    default:
      return state;
  }
};

export default passwordChangeReducer;
